import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { SessionData, SessionDataService } from '../service/session-data.service';
import { SpinnerService } from '../../spinner-component/spinner.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-page-summary',
  templateUrl: './page-summary.component.html',
  styleUrls: ['./page-summary.component.css']
,
  standalone: false
})
export class PageSummaryComponent implements OnChanges {
  @Input() selectedTab: any;
  // totalSessions: number;
  // activeSessions: number;
  // uniqueActive: number;
  activeUsers: number;
  timeRange: string = 'month';
  internalUsers: number;
  externalUsers: number; 
  // allInternalUsers: number;
  // allExternalUsers: number; 
  activeUniqueUsernames: number;
  isInitialLoad: boolean = true;
  startDate: Date | null = null;
  endDate: Date | null = null;
  metricData: any = {};


    // Example data
    totalSessions: number = 100;
    activeSessions: number = 50;
    uniqueActive: number = 80;
    allInternalUsers: number = 30;
    allExternalUsers: number = 20;
  
    // Data source for mat-table
    dataSource = new MatTableDataSource<any>([]);
    instantDS= new MatTableDataSource<any>([]);

  
    // Displayed columns
    displayedColumns: string[] = ['category', 'totalCount'];

  constructor(private sessionDataService: SessionDataService,
    private spinner: SpinnerService
  ) {}

  ngOnInit(): void {
    if (this.isInitialLoad && this.selectedTab == '0') {
        this.applyFilter();
    }
  }

  ngOnChanges(changes: any): void {
    if (!changes.selectedTab || String(changes.selectedTab.currentValue) !== '0') {
      return;
    }

    const previousTab = changes.selectedTab.previousValue;
    if (previousTab !== undefined && previousTab !== null && String(previousTab) !== '0') {
      this.resetDashboardFilters();
    }

    this.applyFilter();
    this.isInitialLoad = false;
  }

  resetDashboardFilters(): void {
    this.timeRange = 'month';
    this.startDate = null;
    this.endDate = null;
  }

  convertDurationToHours(streamDuration) {
    let totalSeconds = 0;
    const durationsInHours:any = {};

    for (let key in streamDuration) {
        const hours = (streamDuration[key] / 60).toFixed(2); // Convert seconds to hours and round to 2 decimal places
        durationsInHours[key] = `${hours} h`;
        totalSeconds += streamDuration[key];
    }

    const totalHours = streamDuration.total ? (streamDuration.total / 60).toFixed(2) : 0;
    durationsInHours.total = `${totalHours} h`;

    return durationsInHours;
  }

  formatNumber(value: number): string {
    if (value >= 1_000_000) {
      return (value / 1_000_000).toFixed(2) + 'M'; // Convert to millions
    } else if (value >= 1_000) {
      return (value / 1_000).toFixed(2) + 'K'; // Convert to thousands
    } else {
      return value.toString(); // Keep as-is for smaller numbers
    }
  }
  updateSummary(fromDate: string, toDate: string) {
    const payload = {
      fromDate: fromDate,
      toDate: toDate,
    };
    this.spinner.activate();
    
    this.sessionDataService.getHistorySummaryMetrics(payload).subscribe(data => {
      data.streamDuration_customer = this.convertDurationToHours(data?.streamDuration_customer || {});
      if (data.totalRequests_customer && data.totalRequests_customer?.total) {
        data.totalRequests_customer.total = this.formatNumber(data?.totalRequests_customer?.total);
      }
      if (data.totalRequests_customer && data.totalRequests_customer.web) {
        data.totalRequests_customer.web = this.formatNumber(data?.totalRequests_customer?.web);
      }
      this.dataSource =  new MatTableDataSource<any>([
        { category: 'Arm/Disarm', uniqueCount: '-', totalCount: '', split: 'true', data: data.armDisarm_customer },
        { category: 'Crime Prevention', uniqueCount: '-', totalCount: '', split: 'true', data: data.crimePrevention_customer },
        { category: 'Footages Downloaded', uniqueCount: '-', totalCount: '', split: 'true', data: data.footagesDownloaded_customer },
        { category: 'Live Views', uniqueCount: '-', totalCount: '', split: 'true', data: data.liveViews_customer },
        { category: 'Site Activity', uniqueCount: '-', totalCount: '', split: 'true', data: data.siteActivity_customer },
        { category: 'Stream Duration', uniqueCount: '-', totalCount: '', split: 'true', data: data.streamDuration_customer },
        { category: 'SD Requests', uniqueCount: '-', totalCount: '', split: 'true', data: data.totalRequests_customer }
      ]);
      setTimeout(()=> {
        this.spinner.deactivate();
      }, 2000);
    });
    /**
    this.sessionDataService.getInstantMetrics(payload).subscribe(data => {
      data.streamDuration = this.convertDurationToHours(data.streamDuration);
      data.totalRequests.total = this.formatNumber(data?.totalRequests.total);
      this.instantDS = new MatTableDataSource<any>([
        { category: 'Arm/Disarm', uniqueCount: '-', totalCount: '', split: 'true', data: data.armDisarm_customer },
        { category: 'Crime Prevention', uniqueCount: '-', totalCount: '', split: 'true', data: data.crimePrevention_customer },
        { category: 'Footages Downloaded', uniqueCount: '-', totalCount: '', split: 'true', data: data.footagesDownloaded_customer },
        { category: 'Live Views', uniqueCount: '-', totalCount: '', split: 'true', data: data.liveViews_customer },
        { category: 'Site Activity', uniqueCount: '-', totalCount: '', split: 'true', data: data.siteActivity_customer },
        { category: 'Stream Duration', uniqueCount: '-', totalCount: '', split: 'true', data: data.streamDuration_customer },
        { category: 'SD Requests', uniqueCount: '-', totalCount: '', split: 'true', data: data.totalRequests_customer }
      ]);
      setTimeout(()=> {
        this.spinner.deactivate();
      }, 2000);
    }); */

    // this.sessionDataService.getSessions().subscribe((sessions: any) => {
    //     let allSessions = sessions?.content;
    //     this.totalSessions = allSessions.length;
    //     let activeSessions = allSessions.filter(session => !session.logoutTimeInIST);
    //     this.activeSessions = activeSessions.length;
    //     const uniqueUsernames = allSessions
    //     .reduce((uniqueUsernames, session) => {
    //       if (!uniqueUsernames.includes(session.username)) {
    //         uniqueUsernames.push(session.username);
    //       }
    //       return uniqueUsernames;
    //     }, []);
        
    //     this.uniqueActive = uniqueUsernames.length;

    //     const allInternalUsers = uniqueUsernames.filter(userName => userName.endsWith('@pro-vigil.com') || !userName.includes('@'));
    //     this.allInternalUsers = allInternalUsers.length;

    //     const allExternalUsers = uniqueUsernames.filter(userName => !userName.endsWith('@pro-vigil.com') && userName.includes('@'));
    //     this.allExternalUsers = allExternalUsers.length;
    // });

    /*this.sessionDataService.getActiveSessions().subscribe((sessions: any) => {
        // console.log(sessions);
        // const uniqueUsernames = sessions
        // .filter(session => !session.logoutTimeInIST)
        // .reduce((uniqueUsernames, session) => {
        //   if (!uniqueUsernames.includes(session.username)) {
        //     uniqueUsernames.push(session.username);
        //   }
        //   return uniqueUsernames;
        // }, []);
        
        // console.log(uniqueUsernames);
        const internalUsers = sessions.content.filter(session => session.username.endsWith('@pro-vigil.com') || !session.username.includes('@'));
        this.internalUsers = internalUsers.length;

        const externalUsers = sessions.content.filter(session => !session.username.endsWith('@pro-vigil.com') && session.username.includes('@'));
        this.externalUsers = externalUsers.length;

        this.activeUsers = sessions.content.length;
        const activeUniqueUsernames = sessions.content.reduce((uniqueUsernames, session) => {
            if (!uniqueUsernames.includes(session.username)) {
                uniqueUsernames.push(session.username);
            }
            return uniqueUsernames;
          }, []);
        this.activeUniqueUsernames = activeUniqueUsernames.length;
    }); */
  }
  onTimeRangeChange(event?: { value: string }) {
    if (event?.value) {
      this.timeRange = event.value;
    }
    if (this.timeRange !== 'custom') {
      this.applyFilter();
    }
  }

  onCustomDateChange() {
    if (this.timeRange === 'custom' && this.startDate && this.endDate) {
      this.applyFilter();
    }
  }
  applyFilter(): void {
    let fromDate: string;
    let toDate: string;
    const currentDate = new Date();
    
    if (this.timeRange === 'day') {
      fromDate = this.formatDateToLocal(currentDate, '00:00:00');
      toDate = this.formatDateToLocal(currentDate, '23:59:59');
      this.updateSummary(fromDate, toDate);
    } else if (this.timeRange === 'week') {
      const startOfWeek = new Date(currentDate);
      startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
      fromDate = this.formatDateToLocal(startOfWeek, '00:00:00');
      toDate = this.formatDateToLocal(currentDate, '23:59:59');
      this.updateSummary(fromDate, toDate);
    } else if (this.timeRange === 'month') {
      const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      fromDate = this.formatDateToLocal(startOfMonth, '00:00:00');
      toDate = this.formatDateToLocal(currentDate, '23:59:59');
      this.updateSummary(fromDate, toDate);
    } else if (this.timeRange === 'custom' && this.startDate && this.endDate) {
      fromDate = this.customFormatDate(this.startDate);
      toDate = this.customFormatDate(this.endDate);
      this.updateSummary(fromDate, toDate);
    } 
    /*else {
      fromDate = this.formatDate(currentDate);
      toDate = this.formatEndDate(currentDate);
    }*/
  }

  customFormatDate(momentDate: any): string {
    const formattedDate =  momentDate.format('YYYY-MM-DD HH:mm:ss');
    return formattedDate;
  }

  formatDate(date: Date): string {
    const localDateString = date.toLocaleDateString('en-US');
    return localDateString.split('T')[0] + ' 00:00:00';
  }

  formatDateToLocal(date: Date, perfix: string): string {
    const localDate = new Date(date.getTime());
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
  
    const formattedDate = `${year}-${month}-${day} ${perfix}`;
  
    return formattedDate;
  }
  

  formatEndDate(date: Date): string {
    return date.toISOString().split('T')[0] + ' 23:59:59';
  }
}
